<script setup lang="ts">
import { LINK_TYPE_ENUM, type V1GetOptions } from "@gasparigit/omnia-sdk";
import Filter from "~/components/icons/Filter.vue";
import Repubblica from "~/components/icons/Repubblica.vue";
import Website from "~/components/icons/Website.vue";
import { processError } from "~/lib/utils/errors";
import { defineSeo } from "~/lib/utils/seo";

const omniaSdk = useOmniaSdk();

const page = usePage();
const options = ref<V1GetOptions>({
  future: true,
  past: false,
  order_mode: "desc",
  publishers: null,
});
const type = ref<"gazzetta" | "portali">("gazzetta");

const areasFilter = ref<string[]>();

const { data, refresh } = useAsyncData(`link-${type.value}`, async () => {
  try {
    return await omniaSdk.v1.contents.list({ areas: areasFilter.value }, type.value, { pagination: "classic", page: page.value }, options.value);
  } catch (error) {
    processError(error);
  }
});

const { data: publishers } = useAsyncData("publishers", async () => {
  try {
    return await omniaSdk.v1.publishers.list({ type: "links" });
  } catch (error) {
    processError(error);
  }
});

watch(options.value, () => {
  refresh();
});

watch(type, () => {
  refresh();
});

const title = computed(() => {
  return type.value === "gazzetta" ? "Oggi in Gazzetta" : "Portali Pubblici";
});

defineSeo({ title: "Oggi in Gazzetta e Portali Pubblici" });
</script>

<template>
  <FrontBreadcrumHero :breadcrumbs="[{ title }]" :title="title" :search="true" :search-filters="{ front_content_type: [type] }" :icon="type === 'gazzetta' ? Repubblica : Website"></FrontBreadcrumHero>

  <div class="main-content">
    <FrontContentsList :title="title" :icon="type === 'gazzetta' ? Repubblica : Website" :link-config="{}" v-model:data="data" v-model:page="page" @update:page="refresh()" :show-areas="true">
      <template #side>
        <FrontRadioGroupCard
          base-key="type"
          v-model="type"
          :icon="Filter"
          title="Filtra per tipologia"
          :options="[
            { value: 'gazzetta', label: 'Oggi in Gazzetta' },
            { value: 'portali', label: LINK_TYPE_ENUM['portali'] },
          ]"
        />

        <FrontCheckboxCard
          v-if="type === 'portali' && publishers?.data.length"
          base-key="publisher"
          name="publisher"
          :options="publishers.data.map((p) => ({ label: p.title, value: p.id }))"
          v-model="options.publishers"
        />

        <FrontAreasFilter v-model="areasFilter" @update:model-value="refresh()" />

        <FrontRadioGroupCard base-key="order" v-model="options.order_mode"></FrontRadioGroupCard>
      </template>
    </FrontContentsList>
  </div>
</template>
